enum InputValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
  WARNING = 'warning',
}

enum InputTypes {
  TEXT = 'text',
  NUMBER = 'number',
  INTEGER = 'integer',
  EMAIL = 'email',
  SEARCH = 'search',
}
enum InputAutoComplete {
  ON = 'on',
  OFF = 'off',
}

enum InputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

enum LabelPosition {
  DEFAULT = '',
  LEFT = 'left'
}

enum InputIconPosition {
  DEFAULT = '',
  RIGHT = 'right'
}

export { InputValidations, InputTypes, InputAutoComplete, InputSize, LabelPosition, InputIconPosition };
